var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-outline-info",attrs:{"disabled":_vm.loading},on:{"click":_vm.download}},[_c('i',{staticClass:"fa fa-download"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }